import { useTranslation } from 'react-i18next'
import { Input } from '@/components/shadcn/input'
import { HelpLabel } from '@/components/common/help/HelpLabel'
import { helpKey } from '@/lib/action-modules/help'
import { isFixedRewardCalculationTypeModel, type FixedRewardCalculationTypeModel, type RewardCalculationTypeEditorProps } from '@/lib/action-modules/registry/reward/types'

export default function FixedRewardEditor(props: RewardCalculationTypeEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const value = props.value
  if (!isFixedRewardCalculationTypeModel(value)) return <>{t('editor.invalidValue')}</>

  return (
    <div className="flex max-w-sm flex-col gap-2">
      <HelpLabel helpKey={helpKey('rewardFixedReward')}>{t('rewardCalculationType.fixed.reward')}</HelpLabel>
      <Input
        type="number"
        value={value.reward}
        onChange={e =>
          props.onChanged({ ...value, reward: Number(e.target.value) } as FixedRewardCalculationTypeModel)
        }
      />
    </div>
  )
}
